<template>
  <div class="housewarming-page">
    <h1>Jess and Lewis</h1>
    <h1>Housewarming</h1>
    <!-- <div class="container"> -->
    <img src="../assets/Jess_and_I_house.jpeg" class="housewarming-header" title="Us and our house, bonkers!"/>
    <!-- </div> -->
    <h1>🗓️12/08/23🗓️</h1>
    <h1>🏡</h1>
    <h1>We Moved to Kent</h1>
    <h1>🎉</h1>
    <div class="flex-grid-thirds">
      <div class="sml-col"/>
      <div class="col">
        <p>In October of 2022 we moved to Folkestone! We would love for you to come celebrate with us on <b>Saturday the 12th of August</b>.</p>
        <h1>⏰</h1>
        <p>Show up anytime from 11am.</p>
        <p>Pro tip: all the cool kids will show up at {{ generateCoolKidTime() }}.</p>
        <h1>🍔</h1>
        <p>We will provide Gluten Free and Veggie/Vegan food, feel free to bring snacks and food yourself if you would like.</p>
        <h1>🥂</h1>
        <p>We will provide alcoholic and non-alcoholic drinks but feel free to bring your own too if you would like.</p>
        <h1>🚂 🚘</h1>
        <p>Our closest station is Folkestone Central (10 min walk).</p>
        <p>Our driveway is first come first served, there is free (time limited) parking near us and plenty of parking in town.</p>
        <h1>🏖️</h1>
        <p>We are a short walk from the beach! Feel free to explore the area and come and go as you please obvs.</p>
        <div class="container">
          <h2 class="centered">See you Soooon x</h2>
          <img src="../assets/Jess_and_I_beach.jpeg" class="housewarming-footer" title="Us at the beach, damn we cute!"/>
        </div>
        
      </div>
      <div class="sml-col"></div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Housewarming',
    methods: {
      generateCoolKidTime() {
        var hour = Math.floor(Math.random() * 24).toLocaleString('en-US', {
            minimumIntegerDigits: 2,
            useGrouping: false
          });
        var min = Math.floor(Math.random() * 60).toLocaleString('en-US', {
            minimumIntegerDigits: 2,
            useGrouping: false
          });
        return `${hour}:${min}`;
      }
    }
  }
</script>
<style scoped>
  @keyframes fadeIn {
    0% { opacity: 0; }
    100% { opacity: 1 }
  }  
  .housewarming-page {
      text-align: center;
      font-size: 16px;
    }
  /** img {
    height: 100%;
    width: 100%;
  }*/
  .housewarming-header {
    height: 100%;
    width: 90%; 
    /*mask-image: linear-gradient(to bottom,  black 0%,rgba(147,147,147,1) 10%,black 100%);*/
    -webkit-mask-image: linear-gradient(to top, black 75%, transparent 100%);
    mask-image: linear-gradient(to top, black 75%, transparent 100%);
    animation: fadeIn 1.7s;
  }

  .housewarming-footer {
    width: 90%; 
    height: 100%;
    /*mask-image: linear-gradient(to bottom,  black 0%,rgba(147,147,147,1) 10%,black 100%);*/
    /*-webkit-mask-image: linear-gradient(to top, black 75%, transparent 100%);
    mask-image: linear-gradient(to top, black 75%, transparent 100%);*/
  }
  h1 {
    font-size: 2.5em;
    text-align: center;
    margin-left: 3px;
    margin-right: 3px;
    display: block;
    color: pink;
    font-family: "IBM Plex Serif", cursive;
  }

  h2 {
    font-size: 1.5em;
    text-align: center;
    display: block;
    color: pink;
    font-family: "IBM Plex Serif", cursive;
  }

   .flex-grid {
  display: flex;
  }
  .col {
    flex: 1;
  }

  .flex-grid-thirds {
    display: flex;
    justify-content: space-between;
  }

  .flex-grid-thirds .col {
    width: 40%;
  }

  .flex-grid-thirds .sml-col {
    width: 10%;
    text-align: left;
  }
  .container {
    position: relative;
    text-align: center;
    color: white;
  }
  .centered {
    position: absolute;
    left: 20%;
    top: 20%;
  }
</style>
